<template>
  <div>
    <div class="parent">
      <v-card @click="$emit('clicked', index)">
        <v-card-title class="info-title">
          <font-awesome-icon
            class="collapse"
            :icon="selected ? 'angle-down' : 'angle-left'"
          />
          <div class="text-center text-padding">
            {{ item.State }}
          </div>
        </v-card-title>
        <div>
          <app-row
            icon="university"
            title="مدرسه مقصد:"
            :value="item.school2"
          />
        </div>
        <div v-if="selected">
          <app-row
            icon="hashtag"
            title="شماره درخواست:"
            :value="item.RequestID"
          />
          <app-row
            icon="university"
            title="مدرسه مبدا:"
            :value="item.school1"
          />

          <div style="padding: 15px">
            <v-row align="center">
              <v-col class="d-flex">
                <b>موافقت مدرسه مبدا:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.StateSchool1 }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>موافقت مدرسه مقصد:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.StateSchool2 }}
              </v-col>
            </v-row>
            
            <template v-if="item.Description.length == 0">
              <template v-if="item.StateKomisyon.trim() != '---.'">
                <v-row align="center">
                  <v-col class="d-flex">
                    <b>موافقت كميسيون:</b>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col class="d-flex content">
                    {{ item.StateKomisyon }}
                  </v-col>
                </v-row>
              </template>
              <v-row align="center">
                <v-col class="d-flex">
                  <b>موافقت مدرسه مقصد:</b>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="d-flex content">
                  {{ item.StateSchool2 }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="d-flex">
                  <b>موافقت نمايندگي:</b>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="d-flex content">
                  {{ item.StateNamayandegi }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="d-flex">
                  <b>موافقت مركز مديريت:</b>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="d-flex content">
                  {{ item.StateMarkaz }}
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row align="center">
                <v-col class="d-flex"><b>توضیحات تکمیلی:</b> </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="d-flex content">
                  {{ item.Description }}
                </v-col>
              </v-row></template
            >
            <v-row v-if="item.Removable" class="ltr">
              <v-btn
                color="red white--text"
                class="register"
                rounded
                @click="$emit('removeRequest', item.RequestID)"
              >
                حذف درخواست
              </v-btn>
            </v-row>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index", "selectedItem"],
  computed: {
    selected() {
      return this.selectedItem == this.index;
    },
    dateRange() {
      return "از " + this.item.AzTarikh + " تا " + this.item.TaTarikh;
    },
  },
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.v-card {
  padding-bottom: 20px;
}
.register {
  margin: 20px 20px 0 20px !important;
}
</style>
